import FairwayRecommendation from './FairwayRecommendation';

export default FairwayRecommendation;
